import React from "react";
import { usePosters } from "../hooks";
import { postersSeo } from "../config";
import { mapPosterToCardProps } from "../services";
import { CollectionIntro } from "../components";
import { ProductGrid } from "../../../shared/index.js";
import {
  postersListConfig,
  resolveListMaxItems,
} from "../../../core/configurations";

/**
 * Posters page.
 */
const Posters = () => {
  const { data } = usePosters();
  const {
    title,
    subtitle,
    tags,
    description,
    ctaLabel,
    coverImages,
    article,
    products,
  } = data;

  const handlePurchase = (poster) => {
    if (poster.purchaseLink) {
      window.open(poster.purchaseLink, "_blank");
    }
  };

  return (
    <div className="Posters">
      <CollectionIntro
        seo={postersSeo}
        cover={{
          title,
          subtitle,
          tags,
          description,
          ctaLabel,
          images: coverImages,
        }}
        article={article}
        searchPlaceholder="Search posters"
      />
      <ProductGrid
        items={products}
        maxItems={resolveListMaxItems(postersListConfig)}
        getCardProps={mapPosterToCardProps}
        getKey={(poster) => poster.id}
        onItemPurchase={handlePurchase}
      />
    </div>
  );
};

export default Posters;
